currencyFormat = (function() {
  var moneyFormat = '$'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

function variantChange(){
   var color = $('.custom_swatch_elements .input-color_swatches:checked').val();
   var size = $('.product-form__item.größe input:checked').val();
   var qty = $('.product-form__item.quantity .bundle--item-content .title');
   var variants = JSON.parse(document.querySelector('#product-data').textContent);
   
   $.each(qty, function(){
       var title = $(this).text();
       title = color + ' / ' + size + ' / ' + title;
       var selectVariant = variants.filter((e) => e.title == title).pop();
       // Choose bundle images change.
       $(this).closest('label').find('.v-img').attr('src',selectVariant.variantImage);
       
       // Choose bundle price change.
       var savedPrice = selectVariant.compare_at_price - selectVariant.price;
       var percent = (savedPrice/selectVariant.compare_at_price) * 100;
       percent = Math.ceil(percent);
       
       if($(this).closest('label').find('.compare-price').length){
          $(this).closest('label').find('.compare-price').text(currencyFormat.formatMoney(selectVariant.compare_at_price, window.money_format.replace('EUR','')));
       }
       if($(this).closest('label').find('.sale-price').length){
          $(this).closest('label').find('.sale-price').text(currencyFormat.formatMoney(selectVariant.price, window.money_format.replace('EUR','')));
       }
       if($(this).closest('label').find('.sale-price').length){
          $(this).closest('label').find('.saved-price span').text(currencyFormat.formatMoney(savedPrice, window.money_format.replace('EUR','')));
       }
       if($(this).closest('label').find('.saved-percent').length){
          $(this).closest('label').find('.saved-percent').text(`${percent}% RABATT`);
       }
       
   });
   var discountPercent = $('.product-form__item.quantity input[type="radio"]:checked').closest('.item').find('.saved-percent').text().replace('RABATT', '').replace('OFF', '').trim();
   $('.discount-percent .num').text(discountPercent);
 }
 
 variantChange();
 
 $('body').on('click', '.custom_swatch_elements .input-color_swatches, .product-form__item.größe input, .product-form__item.quantity input', function(){
     variantChange();
});
// var x = setInterval(function(){
//   if($('.product-single__media-group.slick').hasClass('slick-slider')){
//     $('.product-single__media-group.slick-slider').slick('setPosition');
//     clearInterval(x);
//   }
// });